// extracted by mini-css-extract-plugin
export default {"infoLabel":"epostSidebar_infoLabel__yfscn","infoLabelCol":"epostSidebar_infoLabelCol__OSyb6","newValue":"epostSidebar_newValue__7FQqh"};